export default __webpack_public_path__ + "static/media/P470_CoC.65faf5cb.pdf";